@if (assignee(); as assignee) {
  @let label =
    assignee.isYou
      ? ('INBOX.ASSIGNEE_AVATAR.ASSIGNED_TO_YOU' | translate)
      : ('INBOX.ASSIGNEE_AVATAR.ASSIGNED_TO' | translate: { name: assignee.name });
  <glxy-avatar
    role="img"
    [width]="20"
    [name]="assignee.name"
    [backgroundColor]="backgroundColor()"
    [matTooltip]="label"
    [attr.aria-label]="label"
  ></glxy-avatar>
}
